import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconEditFilled = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="11.5" fill="currentColor" stroke="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0068 6.60398C15.2261 5.82323 13.9602 5.82419 13.1795 6.60612L12.4186 7.36815L16.4224 11.3719L17.1909 10.5834C17.9556 9.79881 17.948 8.54517 17.1739 7.77109L16.0068 6.60398ZM15.3749 12.4466L11.3584 8.43001L6.76557 13.0298C6.23402 13.5621 5.92149 14.2747 5.88988 15.0263L5.82997 16.4506C5.79412 17.3029 6.47449 18.0131 7.32687 18.0132L8.68448 18.0132C9.49323 18.0132 10.268 17.6864 10.8329 17.1068L15.3749 12.4466Z"
      fill="white"
    />
  </SvgIcon>
)
